export enum CacheKeys {
  TRAIN_WARNING_ICON = 'TRAIN_WARNING',
  TRAIN_FIRE_ALARM_ICON = 'TRAIN_FIRE_ALARM',
}
